import Vue from 'vue'
import Vuex from 'vuex'
import authHandler from './modules/auth-handler'
import signupHandler from './modules/signup-handler'
import forgotPasswordHandler from './modules/forgot-password-handler'
import assetHandler from './modules/asset-handler'
import accountRecoveryHandler from './modules/account-recovery-handler'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authHandler,
    signupHandler,
    forgotPasswordHandler,
    accountRecoveryHandler,
    assetHandler
  },
  state: {
    forEmailVerification: true,
    forAdminApproval: false,
    ApiculusEnv: JSON.parse(localStorage.getItem('ApiculusEnv')) || {},
  }
})

store.state.passwordRegex = new RegExp('^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*-]))[0-9a-zA-Z!@#$%&*-]{' + store.state.ApiculusEnv.passwords.minLength +',' + store.state.ApiculusEnv.passwords.maxLength + '}$')

export default store